export const getDeployEnvironment = (url?: string) => {
    const currentURL = url || window.location.href;

    if (
        currentURL.includes(".app") &&
        !currentURL.includes(".ngrok") &&
        !currentURL.includes(".loca")
    )
        return "production";
    if (currentURL.includes(".tech") && !currentURL.includes("-dev")) return "preview";
    return "development";
};
